import React, { useEffect } from 'react';
import messages from 'messages';
import VirtualizedSessionList from 'containers/pages/sessions/VirtualizedSessionList';
import useSelectableObject from 'hooks/utils/useSelectableObject';
import { useParams } from 'react-router-dom';
import { SORT_DATA_TYPES } from 'utils/sort';
import { useSessionsContext } from 'contexts/SessionsContext';
import useSessionSearch from 'hooks/utils/useSessionSearch';
import MessageText from 'components/message/MessageText';
import { FormattedMessage } from 'react-intl';

const columns = [
  {
    key: 'finishedPercentage',
    label: '%',
    sortable: true,
    desc: false,
    dataType: SORT_DATA_TYPES.NUMBER,
    extraProps: { id: 'listItemStatus' } // this prop is only necessary for styles. Most of the times we don't need it
  },
  {
    key: 'name',
    label: 'Session name',
    sortable: true,
    desc: false,
    dataType: SORT_DATA_TYPES.STRING,
    extraProps: { id: 'listItemMainLabel' } // this prop is only necessary for styles. Most of the times we don't need it
  },
  {
    key: 'type',
    label: 'Type',
    sortable: false,
    extraProps: { id: '' } // Empty id === hidden column
  },
  {
    key: 'startdate',
    label: 'Date',
    default: true,
    sortable: true,
    desc: true,
    dataType: SORT_DATA_TYPES.DATE_STRING,
    extraProps: { id: 'listItemLastLabel' } // this prop is only necessary for styles. Most of the times we don't need it
  }
];

function RecurringSessionsList({ onSelected = null, onClick }) {
  const { entityId, sessionId } = useParams();
  const { selected, setSelected } = useSelectableObject();
  const { recurringSessions } = useSessionsContext();
  const [state, setState] = useSessionSearch({
    key: 'name',
    defaultSort: columns.find(c => c.default)
  });

  useEffect(() => {
    setState({ items: recurringSessions });
  }, [recurringSessions]);

  const onSelectSessionsHandler = selected => {
    setSelected(selected);
    onSelected && onSelected(selected);
  };

  return (
    <>
      <VirtualizedSessionList
        refactoring
        activeId={sessionId}
        sortColumns={columns}
        variableHeight
        entityId={entityId}
        items={[...state.filteredItems]}
        selectedItems={[...selected]}
        checkableGroups
        // checkable
        emptyMessage={messages.programDetailAthletesEmpty}
        onClick={onClick}
        onFilter={filter => setState(filter)}
        onSort={sort => setState({ sort })}
        onSelect={selected => {
          onSelectSessionsHandler(selected);
        }}
        filteringTerm={state}
      />
    </>
  );
}

export default RecurringSessionsList;
